import { useEffect, useState } from 'react';
import { calendarWindow, type IsoDate, type Reservation } from '@kratispot/shared';
import { fetchReservations } from '@/lib/api';

// The window the calendar draws, re-read as the day or the floor moves. §15
export function useCalendar(
  venueId: string,
  date: IsoDate,
  today: IsoDate,
  enabled: boolean,
  version: number,
): readonly Reservation[] {
  const [bookings, setBookings] = useState<readonly Reservation[]>([]);
  const days = calendarWindow(date, today);
  const from = days[0]?.date as IsoDate;
  const to = days.at(-1)?.date as IsoDate;

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    fetchReservations(venueId, from, to, controller.signal)
      .then((answer) => setBookings(answer.reservations))
      .catch(() => undefined);
    return () => controller.abort();
  }, [venueId, from, to, enabled, version]);

  return bookings;
}
